import React from "react";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import Loadinguser from "../../../components/Loadingnovel";

function RecentComments({ comment, latestUsers, latestNovelComments }) {
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });
  // gives me current user
  const usersList = latestUsers?.users?.filter(
    (Usercomment) => Usercomment._id === comment.User_id
  );
  const usersNovelList = latestNovelComments?.novels?.filter(
    (Usercomment) => Usercomment._id === comment.Novel_id
  );
  return (
    <div>
      <div className="bg-tertiary h-fit p-8 md:p-10 mt-[100px]">
        <div className="relative h-full flex flex-col justify-between">
          <div ref={ref} className=" gap-y-6 flex flex-col">
            <div className=" flex-nowrap w-full flex justify-start items-center gap-x-4">
              <Link
                to={`/users/${comment.User_id}`}
                title={usersList?.[0]?.firstName}
                className=" flex-none h-[50px] w-[50px] border-tertiary border-2 rounded-full ml-10 z-30 relative"
              >
                {inView && latestUsers.pending === false ? (
                  <div className=" h-full w-full rounded-full object-cover duration-500 ease-in-out">
                    {usersList?.[0]?.picture === "" ? (
                      <div
                        title="My Profile"
                        className="cursor-pointer h-full w-full text-tertiary bg-primary rounded-full relative z-[50] flex justify-center items-center"
                      >
                        {usersList?.[0]?.firstName?.[0]}
                      </div>
                    ) : (
                      <img
                        className=" h-full w-full rounded-full object-cover z-10"
                        src={usersList?.[0]?.picture}
                        alt={usersList?.[0]?.firstName}
                      />
                    )}
                  </div>
                ) : (
                  <div className="flex justify-center items-center h-full w-full rounded-full opacity-20 scale-90 rectangle duration-[0] ease-in-out object-cover">
                    <Loadinguser />
                  </div>
                )}
              </Link>
              <Link
                to={`/novels/${comment?.Novel_id}`}
                title="Novel"
                className="z-20 h-[60px] border-primary border-2 rounded-full w-[60px] absolute top-1/2 -translate-y-1/2 left-0"
              >
                {inView && latestNovelComments.pending === false ? (
                  <div className=" h-full w-full rounded-full object-cover duration-500 ease-in-out">
                    <img
                      className=" h-full w-full rounded-full object-cover z-10"
                      src={usersNovelList?.[0]?.selectedFile}
                      alt={usersNovelList?.[0]?.title}
                    />
                  </div>
                ) : (
                  <div className="flex justify-center items-center h-full w-full rounded-full opacity-20 scale-90 rectangle duration-[0] ease-in-out object-cover">
                    <Loadinguser />
                  </div>
                )}

                <div className="-z-10 absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2">
                  <div className="bg-primary rounded-full z-10 h-[45px] w-[45px] animate-ping "></div>
                </div>
              </Link>
              <div className="z-50 flex-1  w-full flex relative flex-col text-[14px] sm:text-[16px]">
                <Link
                  to={`/users/${comment.User_id}`}
                  title={usersList?.[0]?.firstName}
                  className="text-secondary capitalize w-fit font-SoraS"
                >
                  {usersList?.[0]?.firstName}
                </Link>
                <Link to={`/novels/${comment?.Novel_id}`} className="w-fit">
                  <p className="text-primary linebutton line-clamp-1 capitalize pb-1 leading-6 sm:leading-4 cursor-pointer font-SoraR relative duration-500 ease-in-out">
                    {usersNovelList?.[0]?.title}
                  </p>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="z-30 mt-6 sm:mt-6">
            <div className="mt-2 w-full">
              <p className="text-secondary line-clamp-[10] sm:line-clamp-6 xl:line-clamp-[7] break-words font-SoraR text-[14px] md:text-[16px]">
                {comment?.comment}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecentComments;
